var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning"},[_c('img',{attrs:{"src":"https://res.xiaoxxx.com/urlGather/202306011f20d6696f1499da604351.png","alt":"无权限"}}),_c('p',{staticClass:"hint"},[_vm._v(_vm._s(_vm.word))]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("点击返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }